import type { EpisodeCategory } from '../../../common/enums/episodeCategory';
import type { IEpisodeCategoryBasic } from '../../../common/interfaces/episodeCategory';
import type { IServiceGroupWithServices } from '../../../common/interfaces/servicesByServiceGroupForEpisodeCategory';
import type { IEmployment } from './employment';
import type { IPractitioner } from './practitioner';
import { getSelectedLanguage } from '../../translate';

export enum AddCarePathStep {
    chooseCarePath = 0,
    organizationSettings = 1,
    succesAndSummary = 2,
}

export enum ChooseCarePathStep {
    addPreferredServiceConsumers = 4,
    addRoles = 3,
    addServiceGroups = 2,
    chooseEpisodeCategory = 0,
    chooseProfession = 1,
    updateServiceOrganizationSettings = 5,
}

export interface ICareProviderAddCarePathState {
    carePathStep: ChooseCarePathStep;
    currentStep: AddCarePathStep;
    employment?: IEmployment;
    episodeCategory?: IEpisodeCategoryBasic;
    practitioner?: IPractitioner;
    preSelectedEpisodeCategoryName?: EpisodeCategory;
    serviceGroups?: IServiceGroupWithServices[];
}

export const addCarePathSteps = [
    { title: getSelectedLanguage().episodeCategory.chooseEpisodeCategory },
    { title: getSelectedLanguage().episodeCategory.organizationSettings },
];
